import { Button, Icon as HarfangIcon } from '@elipssolution/harfang';
import { mdiUpload } from '@mdi/js';
import { Stack, Typography } from '@mui/material';
import { ChangeEvent, useCallback, useRef, useState } from 'react';

import useFormat from '../../../../hooks/useFormat';

type DocumentUploadButtonProps = {
	disabled?: boolean;
	maxFiles?: number;
	maxFileSize?: number;
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	uploadedFilesLength?: number;
};

const DocumentUploadButton = ({
	disabled,
	maxFiles,
	maxFileSize,
	onChange,
	uploadedFilesLength,
}: DocumentUploadButtonProps) => {
	const { isMobileFormat } = useFormat();

	const [error, setError] = useState<string>();

	const inputRef = useRef<HTMLInputElement>(null);

	const maxFilesUpload = (maxFiles ?? 0) - (uploadedFilesLength ?? 0);

	const triggerInput = useCallback(() => inputRef.current?.click(), []);

	const handleUpload = (event: ChangeEvent<HTMLInputElement>) => {
		const {
			target: { files },
		} = event;

		if (!files) return;

		if (maxFileSize && Array.from(files).some(({ size }) => size > maxFileSize * 2000000)) {
			setError('Fichier trop lourd (20 Mo max.)');
		} else if (maxFiles && (uploadedFilesLength ?? 0) + files.length > maxFiles) {
			setError(`Trop de fichiers déposés (${maxFilesUpload} max.)`);
		} else {
			!!error && setError(undefined);

			onChange?.(event);
		}
	};

	return (
		<Stack>
			<Button
				disabled={disabled || maxFilesUpload === 0}
				onClick={triggerInput}
				startIcon={<HarfangIcon path={mdiUpload} />}
				variant={isMobileFormat ? 'outlined' : 'contained'}
			>
				{isMobileFormat ? 'Ajouter' : 'Ajouter des documents'}
			</Button>

			<input onChange={handleUpload} ref={inputRef} type="file" hidden multiple />

			{error && (
				<Typography color="error" variant="caption">
					{error}
				</Typography>
			)}
		</Stack>
	);
};

export default DocumentUploadButton;
